import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n);

const messages = {
    en: Object.assign({},
        require('../locales/en.json'),
        require('../locales/en-enum.json'),
        enLocale),
    zh: Object.assign({},
        require('../locales/zh.json'),
        require('../locales/zh-enum.json'),
        zhLocale)
};
const i18n = new VueI18n({
    locale: localStorage.getItem("local") || 'zh',
    fallbackLocale: 'zh',
    silentFallbackWarn: true,
    messages,
});

export default i18n;